import React, { useState, useEffect } from 'react';
import useOs from '../../hooks/Os';
import {
    Sidebar, SidebarNav,
    Container, RowView, Col, Navbar, Heading, Paragraph,
    Button, CardView, Image, Input, Spacer,
    Alert, Badge, ListView, ListItem, Flex, Grid,
    Table, Progress, Spinner, Dropdown, Link,
    Modal, Tabs, Divider, Text,
    useResponsive, MobileOnly, DesktopOnly
} from './index';
import ImageShow from '../../Uitiles/ImageShow';


const SidebarLayout = ({
    sidebar,
    children,
    navbar,
    sidebarPosition = 'left',
    sidebarWidth = '250px',
    isMobile = false,
    isTablet = false,
    isDesktop = false,
    style,
    className,
    ...props
}) => {
    const [isAtTop, setIsAtTop] = useState(true);  // State to track if we're at the top
    const [showSidebar, setShowSidebar] = useState(true);
    const platformInfo = useOs();
    console.log("platformInfo", platformInfo);

    // Safe check for platform - provide fallback if null
    const platform = platformInfo?.os || 'web';

    // Distinguish between native apps and mobile browsers
    const isAndroidApp = platform === 'android'; // Native Android app
    const isIOSApp = platform === 'ios'; // Native iOS app
    const isAndroidBrowser = platform === 'android_browser'; // Chrome/Firefox on Android
    const isIOSBrowser = platform === 'ios_browser'; // Safari on iOS
    const isNativeApp = isAndroidApp || isIOSApp; // Any native app
    const isMobileBrowser = isAndroidBrowser || isIOSBrowser; // Any mobile browser
    const isMobileOS = isNativeApp || isMobileBrowser; // Any mobile (app or browser)

    


    // Detect screen width for responsive behavior
    const screenWidth = typeof window !== 'undefined' ? window.innerWidth : 1200;
    const isSmallScreen = screenWidth < 992;
    const [marginLeft, setMarginLeft] = useState('50px');
    const [marginRight, setMarginRight] = useState('50px');

    const layoutStyles = {
        display: 'flex',
        minHeight: '100vh',
        flexDirection: sidebarPosition === 'left' ? 'row' : 'row-reverse',
        ...style
    };

    useEffect(() => {
        console.log("showSidebar :", showSidebar);
        if (showSidebar) {
            console.log("showSidebar : true");
            console.log("sidebarWidth :", sidebarWidth);
            setMarginLeft(sidebarWidth);
            setMarginRight(sidebarWidth);
        } else {
            console.log("showSidebar : false");
            console.log("sidebarWidth :", '50px');
            setMarginLeft('50px');
            setMarginRight('50px');
        }
    }, [showSidebar]);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);  // Add scroll event listener
        return () => window.removeEventListener('scroll', handleScroll);  // Cleanup the event listener when the component is unmounted
    }, []);

    const handleScroll = () => {
        console.log("window.scrollY :", window.scrollY);
        if (window.scrollY === 0) {
            console.log("window.scrollY is at the top");
            setIsAtTop(true);  // If the scroll position is at the top, set state to true
        } else {
            console.log("window.scrollY is not at the top");
            setIsAtTop(false);  // If scrolled down, set state to false
        }
    };


    const mainContentStyles = {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        // Different padding for native apps vs browsers
        padding: isNativeApp ? '0px' : isMobileBrowser ? '15px' : '20px',
        marginLeft: sidebarPosition === 'left' && !isSmallScreen && !isMobile ? marginLeft : '0',
        marginRight: sidebarPosition === 'right' && !isSmallScreen && !isMobile ? marginRight : '0',
        transition: 'margin 0.3s ease',
        overflowX: 'hidden'
    };

    return (
        <div className={`sidebar-layout ${className || ''}`} style={layoutStyles} {...props}>
            <div className="sidebar-container">
                <Sidebar
                    position="left"
                    width="250px"
                    bg="#2c3e50"
                    fixed={true}
                    collapsible={true}
                    useMobileOffcanvas={true}
                    style={{ color: 'white' }}
                    showSidebar={showSidebar}
                    setShowSidebar={setShowSidebar}
                >
                    {sidebar} {/* Sidebar component is passed here */}
                </Sidebar>
            </div>
            <main className="main-content" style={mainContentStyles} data-sticky={isAtTop}>
                {/* Top Navbar */}
                <Navbar
                    bg="white"
                    variant="light"
                    style={{
                        borderBottom: '1px solid #dee2e6',
                        marginBottom: '20px',
                        boxShadow: isAtTop ? '0 2px 8px rgba(0,0,0,0.1)' : 'none',
                        borderRadius: isAtTop ? '5px' : '0',
                        height: isAtTop ? '60px' : '70px',
                        marginLeft: !isAtTop && showSidebar && !isSmallScreen && !isMobile? "250px" : !isAtTop ? !isSmallScreen && !isMobile? '50px' : '0px' : '0px',
                        width: "-webkit-fill-available",
                        transition: 'margin 0.3s ease',
                        padding: "20px",
                    }}
                    className={`dc-navigationarea${isAtTop ? '' : ' stickymain'}`}
                >
                    {navbar}
                </Navbar>
                {children}
            </main>
        </div>
    );
};


export default SidebarLayout;
